import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import '../../styles/login-register/login-register.scss';
import Grid from '@material-ui/core/Grid';
import HeaderAuth from '../includes/HeaderAuth';

//Milan Andrejic
import { Redirect } from 'react-router';

class EmailSent extends React.Component {
  state = {
    redirectToNextStep: false,
  };
  redirectToLandingPage = () => {
    this.setState({ redirectToNextStep: true });
  };

  render() {
    if (this.state.redirectToNextStep) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { finishMessage: 'bravo' },
          }}
        />
      );
    }
    return (
      <Grid spacing={0} container>
        <Grid
          className={'forgot-password-background b-entry-background'}
          item
          xs={12}
        >
          <HeaderAuth type="" />
          <Grid
            className="center-vertically"
            container
            alignItems={'center'}
            justify={'center'}
          >
            <Grid
              item
              xs={11}
              sm={5}
              lg={3}
              className="b-entry-credentials-wrapper"
            >
              <div className="b-entry-credentials-wrapper__text">
                <h3 className="b-entry-credentials-wrapper__text t-primary-24 t-color-w">
                  Email Sent
                </h3>
                <span className="b-entry-credentials-wrapper__text t-secondary-16 t-color-w">
                  Follow instructions from email to set up a new password
                </span>
              </div>

              <Button
                variant="contained"
                color="primary"
                fullWidth
                className="u-mrg-top-50 t-weight-b"
                onClick={this.redirectToLandingPage}
              >
                Back to landing page
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default EmailSent;
